module.exports = __webpack_public_path__ + "static/img/title_box.cf480e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/活动模板/title_box.jpg
// module id = V3fy
// module chunks = 1